<template>
  <router-link class="link" :to="profileRoute()">
    <Avatar
      class="avatar"
      v-if="investor?.user"
      :userName="investor.user.name"
      :imageUrl="investor.user.avatar"
      size="large"
      :showSingleLetter="true"
    />
  </router-link>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';

import { Avatar } from '@tallo/design-system';
import { useInvestorStore } from '@tallo/investor/investor';
import { profileRoute } from '@tallo/investor/navigation';

const investorStore = useInvestorStore();
const { investor } = storeToRefs(investorStore);
</script>

<style scoped lang="scss">
.link {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.avatar {
  background-color: var(--t-color-orange-500) !important;
  color: #fff;
}
</style>
